// `colSpan` defaults to the widest table that uses this, so a caller that
// forgets it still spans most of the row rather than collapsing to one cell.
// Pass the real count: a table that grows a column and leaves this behind
// draws its empty state under only part of the header.
const NoContent = ({ searchValue, title, colSpan = 13 }) => {
    return (
        <tr className="content">
            <td colSpan={colSpan} className="books_cell">
                <div className="books_container">
                    <div className="books_icon">
                        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <h3 className="books_title">{`No ${title} has been found`}</h3>
                    <p className="books_message">
                        {searchValue ?
                            `No ${title} match your search "${searchValue}". Try adjusting your search criteria.` :
                            `There are no ${title} available at the moment. Add some ${title} to get started.`
                        }
                    </p>
                </div>
            </td>
        </tr>
    )
}

export default NoContent;   